import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={56}
            height={56}
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={4} y={4} width={48} height={48} rx={24} fill={theme["#B4E3E1"]} />
            <path
                d="M33 26v-2a5 5 0 00-10 0v2m5 4.5v2M24.8 37h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C36 34.72 36 33.88 36 32.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C33.72 26 32.88 26 31.2 26h-6.4c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C20 28.28 20 29.12 20 30.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C22.28 37 23.12 37 24.8 37z"
                stroke={theme["#0D968F"]}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x={4}
                y={4}
                width={48}
                height={48}
                rx={24}
                stroke={theme["#E7F6F5"]}
                strokeWidth={8}
            />
        </svg>
      )
}
  
  export default SvgComponent